var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`a-dotted-line${_vm.fullWidth ? ' full-width': ''}`},[_c('div',{staticClass:"dotted-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }